/**
 * Separates thousands with a dot
 *
 * @param {String|Number} value
 * @returns {String}
 */
export default function separateThousands(value: any): string {
  return String(value).indexOf(',') > -1
    ? `${value.split(',')[0].replace(/(\d)(?=(\d{3})+([.]|$))/g, '$1.')},${value.split(',')[1]}`
    : String(value).replace(/(\d)(?=(\d{3})+([.]|$))/g, '$1.');
}
